import React, { Component } from 'react';
import { toast } from '../../utilities/appToast';
import { formatoDecimal } from '../../utilities/formatoNumeros'
import { getLogoPlataformaById, getLabelEstadoById, idEstadosOrden, normalizeIdEstadoOrden } from "../../helper/ordenHelper";
import PropTypes from 'prop-types';
import './OrdenesStyles.css';

const PLACEHOLDER_PRODUCTO_IMG =
    'https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png';

const resolveProductImageSrc = (src) => {
    const value = src != null ? String(src).trim() : '';
    return value || PLACEHOLDER_PRODUCTO_IMG;
};

export default class OrdenListItem extends Component {
    copyAlPortapapeles = async (e, valor, etiqueta) => {
        e.stopPropagation();
        if (valor === undefined || valor === null || valor === '') return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${etiqueta} copiado`);
        } catch {
            toast.error('No se pudo copiar al portapapeles');
        }
    };

    copyTargetKeyDown = (e, valor, etiqueta) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.copyAlPortapapeles(e, valor, etiqueta);
        }
    };

    /** span + role="button": evita button anidado cuando la fila padre es un botón (p. ej. ListOrdenes). */
    renderCopyControl = (valor, etiqueta, children, className, title) => (
        <span
            role="button"
            className={className}
            title={title}
            tabIndex={0}
            onClick={(e) => this.copyAlPortapapeles(e, valor, etiqueta)}
            onKeyDown={(e) => this.copyTargetKeyDown(e, valor, etiqueta)}
        >
            {children}
        </span>
    );

    render = () => {
        const {
            idOrden,
            idReferencia,
            seller,
            fecha,
            cliente,
            estado,
            tipoEntrega,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            showComision,
            importeComision,
            anulacionMegatone
        } = this.props;
        const changeTipoEntrega = (tipoEntrega) => {
            if (!tipoEntrega) return;
            return (tipoEntrega.includes("sucursal correo")) ? "Env\u00CDo a domicilio" : tipoEntrega;
        }

        const reversoVisible = idReferencia !== undefined
            && idReferencia !== null
            && String(idReferencia).trim() !== ''
            && String(idReferencia).trim() !== '0';

        const ordenAnulada =
            anulacionMegatone?.anulado === true ||
            (Array.isArray(estado) && estado.some((e) => normalizeIdEstadoOrden(e.idEstado) === idEstadosOrden.anulado));
        const idEstadoBadge = ordenAnulada ? idEstadosOrden.anulado : normalizeIdEstadoOrden(estado?.[0]?.idEstado) ?? estado?.[0]?.idEstado;

        const cardEstadoClass =
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.anulado ? 'orden-card-estado-anulada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.facturado ? 'orden-card-estado-facturada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.pendiente ? 'orden-card-estado-pendiente' : '';

        const logoPlataforma = getLogoPlataformaById(plataformaCodigo);

        return (
            <div
                className={`w-100 list-group-item hover-background-color orden-card-por-estado ord-card ${cardEstadoClass}`.trim()}
            >
                <div className="ord-row">
                    <div className="ord-row__identity">
                        <span className="ord-row__seller">{seller}</span>
                        <span className="ord-row__date">{fecha?.slice(0, 10)}</span>
                        {this.renderCopyControl(idOrden, 'N° orden', `#${idOrden}`, 'ord-row__id orden-copy-id', 'Clic para copiar N° orden')}
                        {reversoVisible && (
                            <span className="ord-row__ref">
                                Reverso{" "}
                                {this.renderCopyControl(idReferencia, 'Reverso', idReferencia, 'orden-copy-id', 'Clic para copiar reverso')}
                            </span>
                        )}
                    </div>

                    <div className="ord-row__client">
                        <span className="ord-row__client-name">{cliente}</span>
                        {mailCliente && mailCliente.length > 0 ? <span className="ord-row__client-mail">{mailCliente}</span> : null}
                        {logoPlataforma ? (
                            <img src={logoPlataforma} alt="" className="ord-row__platform" />
                        ) : null}
                        {dniIdBocaSeller != 0 && dniIdBocaSeller ? <span className="ord-row__boca">{dniIdBocaSeller}</span> : null}
                    </div>

                    <div className="ord-row__products">
                        {Array.isArray(productos) && productos.map((producto, i) => (
                            <div className="ord-row__product" key={`${producto.sellerSku}${i}`}>
                                <img
                                    alt="user-img"
                                    className="ord-row__thumb"
                                    src={resolveProductImageSrc(producto.imagenPrincipal)}
                                    loading="lazy"
                                    decoding="async"
                                />
                                <div className="ord-row__product-body">
                                    <h6 className="ord-row__product-title">
                                        <small>{producto.cantidad}x </small>
                                        {this.renderCopyControl(producto.titulo, 'Nombre del producto', producto.titulo, 'orden-copy-id', 'Clic para copiar nombre del producto')}
                                    </h6>
                                    <p className="ord-row__product-meta">
                                        <span>
                                            Precio unitario{" "}
                                            {this.renderCopyControl(producto.precioUnitario, 'Precio unitario', `$${formatoDecimal(producto.precioUnitario)}`, 'orden-copy-id', 'Clic para copiar precio unitario')}
                                        </span>
                                        <span>
                                            SKU seller{" "}
                                            {this.renderCopyControl(producto.sellerSku, 'SKU seller', producto.sellerSku, 'orden-copy-id', 'Clic para copiar SKU seller')}
                                        </span>
                                        <span>
                                            SKU market{" "}
                                            {this.renderCopyControl(producto.skuMarket, 'SKU market', producto.skuMarket, 'orden-copy-id', 'Clic para copiar SKU market')}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="ord-row__side">
                        <div className="ord-row__amount">
                            <span>${formatoDecimal(montoVenta)}</span>
                            <small>Monto venta</small>
                        </div>
                        {showComision && (
                            <div className="ord-row__amount ord-row__amount--secondary">
                                <span>${formatoDecimal(importeComision)}</span>
                                <small>Comisión</small>
                            </div>
                        )}
                        <span className={`label label-${getLabelEstadoById(idEstadoBadge).color} orden-estado-label`}>
                            {getLabelEstadoById(idEstadoBadge).label}
                        </span>
                        <p className="ord-row__delivery">{changeTipoEntrega(tipoEntrega)}</p>
                        {ordenAnulada && anulacionMegatone?.motivoAnulacion ? (
                            <p className="ord-row__delivery">{anulacionMegatone.motivoAnulacion}</p>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
OrdenListItem.propTypes = {
    idOrden: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idReferencia: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    seller: PropTypes.string,
    fecha: PropTypes.string,
    cliente: PropTypes.string,
    estado: PropTypes.arrayOf(PropTypes.shape({
        idEstado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })),
    tipoEntrega: PropTypes.string,
    montoVenta: PropTypes.number,
    productos: PropTypes.array,
    mailCliente: PropTypes.string,
    dniIdBocaSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    plataformaCodigo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showComision: PropTypes.bool,
    importeComision: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    anulacionMegatone: PropTypes.shape({
        anulado: PropTypes.bool,
        motivoAnulacion: PropTypes.string,
    }),
}